class Store {
  constructor() {
    this.cart = null;
    // this.brandLimits = null;
    // this.productLimits = null;
    this.brandLimits = window.brandLimits;
    this.productLimits = window.productLimits;
    this.enableGlobalProductLimit = window.enableGlobalProductLimit;
    this.globalProductLimit = window.globalProductLimit;

    // console.log('brand limits in store constructor: ',  this.brandLimits);
    // console.log('product limits in store constructor: ', this.productLimits);

    this.limitsReached = {
      brand: [],
      product: [],
    };
    this.init();
    this.cartLock = false;
  }

  async init() {
    console.log("store init");
  }

  fetchConfig(type = "json") {
    return {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: `application/${type}`,
      },
    };
  }

  /**
   * @param {Cart} cart
   * @returns {void}
   */
  saveCartToSessionStorage(cart) {
    // console.log('saving cart to session storage');
    sessionStorage.setItem("knockingCart", JSON.stringify(cart));
  }

  /**
   * @returns {void}
   */
  deleteCartFromSessionStorage() {
    console.log("Deleting cart from session storage");
    sessionStorage.removeItem("knockingCart");
  }

  /**
   * @param {Cart} newCart
   * @returns {Promise<Cart | null>}
   * */
  async updateCart(newCart) {
    // console.log("update cart: ", newCart);
    let cart;
    if (newCart === null) {
      cart = await this.fetchCartAndAddLimits();
    } else {
      cart = this.updateLimitsInCart(newCart);
    }
    if (!cart) {
      console.error("Unabable to update cart limits!");
      return null;
    }
    cart = await this.updateVoucherCodesInCart(cart);
    if (!cart) {
      console.error("Unabable to update cart voucher codes!");
      return null;
    }

    this.saveCartToSessionStorage(cart);
    knocking.checkLimits(cart);
    messenger.emmit(messenger.topics.UPDATE_CART_BUBBLE, cart.item_count);

    return cart;
  }

  /**
   * @param {number} line;
   * @param {number} quantity;
   * @returns {Promise<Cart | null>}
   * */
  async updateCartQuantity(line, quantity) {
    // console.log('updating cart quantity: ', line, quantity);
    const body = JSON.stringify({
      line,
      quantity,
    });
    const res = await fetch(`${routes.cart_change_url}`, {
      ...store.fetchConfig(),
      ...{ body },
    });
    const json = await res.json();
    if (json.errors) {
      // console.log("json in upadateCartQuantity: ", json);
      messenger.emmit(messenger.topics.LINE_ITEM_ERROR, {
        line,
        error: json.errors,
      });
      return null;
    }

    const updatedCart = await this.updateCart(json);
    return updatedCart;
  }

  /**
   * @param {number} line;
   * @param {string} property;
   * @param {string | string[]} value;
   * @param {number} qty;
   * @returns {Promise<void>}
   * */
  async updateCartProperty(line, property, value, qty) {
    const body = JSON.stringify({
      line,
      quantity: qty,
      properties: {
        [property]: value,
      },
    });

    try {
      const res = await fetch(`${routes.cart_change_url}`, {
        ...store.fetchConfig(),
        ...{ body },
      });
      const json = res.json();
      // console.log("successfully updated cart property: ", json);
      // this.updateCart(json);
      return json;
    } catch (error) {
      console.error("error updating cart property: ", error);
    }
  }

  async clearCart() {
    const res = await fetch(`${routes.cart_clear_url}`, { method: "POST" });
    // console.log('res: ', res);
    const json = await res.json();
    console.log("successfully cleared cart: ", json);
    await this.updateCart(json.body);
    return json;
  }

  // Public methods
  /**
   * @param {string} payload
   * @param {string | null} gtmCustomEvent
   * @returns {Promise<Cart | null>}
   * */
  async addToCart(payload) {
    console.log('addToCart method in knocking-store: ', JSON.parse(payload));
    const res = await fetch(`${routes.cart_add_url}`, {
      ...store.fetchConfig("javascript"),
      body: payload,
    });
    const json = await res.json();
    // console.log("addToCart response in knocking-store: ", json);
    if (json.status === 422) {
      throw new Error(json.description);
    }
    const newCart = await this.fetchCartAndAddLimits();
    // console.log("newCart in knocking-store: ", newCart);
    if (!newCart) {
      console.error("Unable to fetch cart!");
      return null;
    }

    this.saveCartToSessionStorage(newCart);
    messenger.listen(
      messenger.topics.CART_READY,
      () => {
        knocking.openCart();
      },
      "KnockingStore"
    );
    knocking.buildCart(newCart);
    return newCart;
  }

  /**
   * @param {number} line;
   * @returns {Promise<void>}
   * */
  async removeItem(line) {
    const oldCart = await store.getCart();
    if (!oldCart) {
      console.error("Unable to get cart!");
      return;
    }
    const variantToDelete = oldCart.items[line - 1].variant_id;
    console.log("variant to delete: ", variantToDelete);
    let newCart = await store.updateCartQuantity(line, 0);
    if (!newCart) {
      console.error("Unable to update cart quantity!");
      return;
    }
    console.log("new cart: ", newCart);

    // check if there is a custom sku product in the cart
    const customSkuProductIndex = newCart.items.findIndex((item) => item.properties["_custom-sku-variant"] && item.properties["_variant-to-customize"] === variantToDelete.toString());
    if (customSkuProductIndex !== -1) {
      // remove the custom sku product from the cart
      newCart = await store.updateCartQuantity(customSkuProductIndex + 1, 0);
      console.log("removed custom sku product from cart");
    }

    knocking.buildCart(newCart);
    console.log("adding variant to deleted variants list");
    store.addToDeletedVariantsList(variantToDelete);
  }

  /**
   * @param {number} variantId
   * @returns {void}
   * */
  addToDeletedVariantsList(variantId) {
    const deletedVariantsList = JSON.parse(
      sessionStorage.getItem("deletedVariantsList") || "[]"
    );
    deletedVariantsList.push(variantId);
    sessionStorage.setItem(
      "deletedVariantsList",
      JSON.stringify(deletedVariantsList)
    );
  }

  /**
   * @param {number} variantId
   * @returns {boolean}
   * */
  checkDeletedVariantsListForVariant(variantId) {
    const deletedVariantsList = JSON.parse(
      sessionStorage.getItem("deletedVariantsList") || "[]"
    );
    return deletedVariantsList.includes(variantId);
  }

  /**
   * @returns {Promise<Cart | null>}
   * */
  async getCart() {
    const cachedCart = sessionStorage.getItem("knockingCart");
    if (cachedCart) {
      // console.log('returning cached cart: ', JSON.parse(cachedCart));
      return JSON.parse(cachedCart);
    } else {
      // console.log('no cached cart, fetching cart');
      const cart = await this.fetchCartAndAddLimits();
      // console.log('returning fetched cart: ', cart);
      return cart;
    }
  }

  // Helpers
  /**
   * @param {Cart} cart
   * @returns {Cart | null}
   */
  updateLimitsInCart(cart) {
    // console.trace('updating limits in cart: ', cart);
    if (!cart) {
      return null;
    }

    if (cart.items.length === 0) {
      return cart;
    }

    // Product limits
    /**
     * @type {number[] | never}
     */
    let checkedProducts = [];
    for (const item of cart.items) {
      if (checkedProducts.includes(item.product_id)) {
        continue;
      }
      /**
       * @typedef {Object} pLimit
       * @property {boolean} limitReached
       * @property {number | null} remainingQty
       * @property {string} type
       * @property {number} quantity
       * */

      /**
       * @type {pLimit}
       * */
      let pLimit = {
        limitReached: false,
        remainingQty: null,
        type: "product",
      };

      const productLimit = this.getLimitForProduct(item.product_id);
      // console.log('product limit: ', productLimit);
      if (productLimit) {
        const accumulatedQty = cart.items.reduce(
          (acc, i) =>
            i.product_id == item.product_id ? acc + i.quantity : acc,
          0
        );

        if (accumulatedQty >= productLimit) {
          pLimit.limitReached = true;
        } else {
          pLimit.limitReached = false;
        }
        pLimit.remainingQty = productLimit - accumulatedQty;
        // console.log(`adding limit to product ${item.title}: `, pLimit);
        item.limit = pLimit;
      }
      checkedProducts.push(item.product_id);
    }

    // Collection limits
    for (const itemA of cart.items) {
      if (itemA.limit) {
        continue;
      }
      itemA.limit = {
        limitReached: false,
        remainingQty: null,
        type: "none",
      };

      if (this.brandLimits[itemA.vendor]) {
        let vendorItemsInCart = [];
        for (const itemB of cart.items) {
          if (itemB.vendor === itemA.vendor) {
            const itemHasProductLimit = knocking.getProductLimit(
              itemB.product_id.toString()
            )
              ? true
              : false;
            // console.log(
            //   `checking if item ${itemA.title} has product limit: ${itemHasProductLimit}`
            // );
            if (!itemHasProductLimit) {
              vendorItemsInCart.push(itemB);
            }
          }
        }

        // console.log('vendor items in cart: ', vendorItemsInCart);

        const alreadyInCart = vendorItemsInCart.reduce(
          (acc, i) => acc + i.quantity,
          0
        );

        // console.log('already in cart: ', alreadyInCart);

        if (alreadyInCart >= this.brandLimits[itemA.vendor]) {
          itemA.limit.remainingQty = 0;
          itemA.limit.limitReached = true;
        } else {
          itemA.limit.limitReached = false;
          itemA.limit.remainingQty =
            this.brandLimits[itemA.vendor] - alreadyInCart;
        }
        itemA.limit.type = "brand";
        itemA.limit.quantity = this.brandLimits[itemA.vendor];
      }
    }

    if (window.enableGlobalProductLimit) {
      // console.log("checking global product limit in cart")
      for (const item of cart.items) {
        if (item.limit.type === "product" || item.limit.type === "brand") {
          continue;
        }
        item.limit = {
          limitReached: false,
          remainingQty: null,
          type: "none",
        };
        if (this.globalProductLimit) {
          // console.log("adding global limit to product: ", item.title)
          const accumulatedQty = cart.items.reduce(
            (acc, i) =>
              i.product_id == item.product_id ? acc + i.quantity : acc,
            0
          );
          if (accumulatedQty >= this.globalProductLimit) {
            item.limit.limitReached = true;
          } else {
            item.limit.limitReached = false;
          }
          item.limit.remainingQty = this.globalProductLimit - accumulatedQty;
          item.limit.type = "global";
        }
      }
    }
    // console.log('cart after limits: ', cart);
    return cart;
  }

  /**
   * @param {number} id
   * @returns {number | null}
   * */
  getLimitForProduct(id) {
    if (!id) {
      return null;
    }
    const idString = id.toString().trim();
    if (this.productLimits[idString]) {
      return this.productLimits[idString];
    }
    return null;
  }
  /**
   * @param {string} vendor
   * @returns {number | null}
   * */
  getLimitForBrand(vendor) {
    if (!vendor) {
      return null;
    }
    const vendorString = vendor.toString().trim();
    if (this.brandLimits[vendorString]) {
      return this.brandLimits[vendorString];
    }
    return null;
  }

  // Operations

  /**
   * @returns {Promise<Cart | null>}
   */
  async fetchCartAndAddLimits() {
    this.cartLock = true;
    try {
      // console.log('fetching cart');
      const res = await fetch("/cart.js");
      const newCart = await res.json();
      this.cart = newCart;
      // console.log('fetched cart: ', this.cart);
      const updatedCart = this.updateLimitsInCart(newCart);
      if (updatedCart) {
        this.saveCartToSessionStorage(updatedCart);
      }
      this.cartLock = false;
      return updatedCart;
    } catch (error) {
      console.log("error getting cart: ", error);
      return null;
    }
  }

  /**
   * @param {Cart} cart
   * @returns {Promise<Cart | null>}
   */
  async updateVoucherCodesInCart(cart) {
    let changesMade = 0;

    for (let i = 0; i < cart.items.length; i++) {
      const item = cart.items[i];
      const vendor = item.vendor;
      const qty = item.quantity;
      if (!item.properties || !item.properties["_encoded-vouchers"]) {
        continue;
      }
      if (item.properties["_encoded-vouchers"].length === qty) {
        continue;
      }
      let vouchers = item.properties["_encoded-vouchers"];
      if (typeof vouchers === "string") {
        vouchers = JSON.parse(vouchers);
      }
      // console.log("vouchers: ", vouchers);
      // console.log(typeof vouchers);

      if (vouchers.length > qty) {
        // console.log("removing vouchers");
        const newVoucherArray = vouchers.slice(0, qty);
        // console.log("new voucher array: ", newVoucherArray);
        const updatePropertyRes = await store.updateCartProperty(
          i + 1,
          "_encoded-vouchers",
          newVoucherArray,
          qty
        );

        changesMade++;
        continue;
      }
      if (vouchers.length < qty) {
        // console.log("adding vouchers");
        const codesToAdd = qty - vouchers.length;
        // console.log("codes to add: ", codesToAdd);
        const newVouchers = await knocking.getVoucherCode(
          vendor,
          item.sku,
          codesToAdd
        );
        // console.log("new vouchers: ", newVouchers);
        const newVoucherArray = newVouchers ? [...vouchers, ...newVouchers] : vouchers;
        // console.log("new voucher array: ", newVoucherArray);

        const updatePropertyRes = await store.updateCartProperty(
          i + 1,
          "_encoded-vouchers",
          newVoucherArray,
          qty
        );
        // console.log("update property res: ", updatePropertyRes);
        changesMade++;
        continue;
      }
    }
    if (changesMade > 0) {
      const cart = await store.fetchCartAndAddLimits();
      // console.log("cart after voucher changes: ", cart);
      return cart;
    } else {
      return cart;
    }
  }

  /**
   * @param {number | string} variantId
   * @returns {Promise<Item | null>}
   */
  async checkIfVariantIsInCart(variantId) {
    variantId = typeof variantId === "string" ? parseInt(variantId) : variantId;
    const cart = await this.getCart();
    if (!cart) {
      console.error("Unable to get cart!");
      return null;
    }
    const item = cart.items.find((i) => i.id === variantId);
    if (item) {
      return item;
    }
    return null;
  }

  /**
   * @param {number | string} variantId
   * @returns {Promise<number | null>}
   */
  async getLineNumberOfItem(variantId) {
    variantId = typeof variantId === "string" ? parseInt(variantId) : variantId;
    const cart = await this.getCart();
    const index = cart.items.findIndex((i) => i.id === variantId);
    if (index !== -1) {
      return index + 1;
    }
    return null;
  }
}

const store = new Store();
